<template>
  <div>
    <LoadingPanel :loading="loading" />
    <div v-if="hasActivityItems">
      <strong>{{title}}</strong>
      <div class="activity-event-list">
        <div class="item" v-for="activity in activityLogList" :key="activity.id">
          <div class="description">
            <LinkUser v-if="activity.user" :id="activity.user.id" :name="activity.user.name" />
            {{activity.message}}
            <div v-if="activity.extraDetails">
              {{activity.extraDetails}}
            </div>
          </div>
          <span class="date">{{activity.createdAt | formatCalenderDate}}</span>        
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ActivityLogItem from '@/components/activityLogItem'

export default {
  name: 'ActivityLogEventList',
  components: {
    ActivityLogItem
  },
  props: {
    title: String,
    linkType: String,
    linkId: Number,
    eventTag: String,
    activityStreamURL: String
  },
  data() {
    return {
      loading: false,
      activityLogList: []
    }    
  },
  computed: {
    hasActivityItems() {
      return this.activityLogList.length > 0
    }
  },
  watch: {
    linkType: function() {
      this.requestData()
    },
    linkId: function() {
      this.requestData()
    },
    eventTag: function() {
      this.requestData()
    },
    activityStreamURL: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.activityLogList = []

      var params = {
        'filter[eventTag]': this.eventTag
      }
      let url = `${this.activityStreamURL}?` + this.buildQueryParams(params)

      this.loading = true
      this.$api.get(url)
      .then(response => {
        this.activityLogList = response.data.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    }
  }
}
</script>